module.exports = __webpack_public_path__ + "img/enedis.e99e1321.jpg";